import { render } from "./economia.vue?vue&type=template&id=7732fd6e&scoped=true"
import script from "./economia.vue?vue&type=script&lang=js"
export * from "./economia.vue?vue&type=script&lang=js"

import "./economia.vue?vue&type=style&index=0&id=7732fd6e&scoped=true&lang=scss"

import exportComponent from "/var/www/amee/gdaudit-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7732fd6e"]])

export default __exports__